import styled, {css} from 'styled-components';

type WrapperProps = {
    disabled?: boolean;
    withLabel: boolean;
};

type BoxProps = {
    selected: boolean;
};

export const Box = styled.div<BoxProps>`
    padding: 3px;
    background-color: transparent;
    border: 1px solid hsl(0, 0%, 90%);
    border-radius: 4px;
    line-height: 0;
    color: white;
    position: relative;
    transition: background-color linear 0, border-color ease-in-out 200ms;

    &::before {
        content: '';
        top: 0.5px;
        left: 0;
        bottom: -0.5px;
        right: 0;
        position: absolute;
        background: black;
        border-radius: 4px;
        transform: scale(0);
        transition: transform ease-in-out 200ms;
        z-index: -1;
    }

    svg {
        opacity: 0;
    }

    ${({selected}) =>
        selected &&
        css`
            transition: background-color linear 10ms 300ms,
                border-color ease-in-out 300ms;

            background-color: black;
            border-color: black;

            &::before {
                transition: transform ease-in-out 300ms;
                transform: scale(1) !important;
            }

            svg {
                opacity: 1;
            }
        `};
`;

export const Wrapper = styled.div<WrapperProps>`
    display: flex;
    align-items: center;
    cursor: pointer;
    max-width: max-content;

    input {
        display: none;
    }

    ${({withLabel}) =>
        withLabel &&
        css`
            margin: 6px 0;

            ${Box} {
                margin-right: 8px;
            }
        `}
    &:hover ${Box} {
        border-color: black;

        &::before {
            transform: scale(0.2);
        }
    }

    &:active ${Box} {
        &::before {
            transform: scale(0);
        }
    }

    ${({disabled}) =>
        disabled &&
        css`
            pointer-events: none;
        `}
`;
